// ─── Base de chemin — dépend du mode de build ────────────────────────────────
// CRM VPS      (REACT_APP_VITRINE_MODE absent)  → '/pitboard-suite'
// Vitrine VPS  (REACT_APP_VITRINE_MODE=true)    → ''
const VITRINE_BASE = process.env.REACT_APP_VITRINE_MODE === 'true' ? '' : '/pitboard-suite';

// ─── Navigation ─────────────────────────────────────────────────────────────
export const NAV_ITEMS = {
  fr: [
    { label: 'Accueil',          href: '#accueil' },
    { label: 'Fonctionnalités',  href: '#fonctionnalites' },
    { label: 'Solutions',        href: '#solutions' },
    { label: 'Sécurité',         href: '#securite' },
    { label: 'Tarifs',           href: '#tarifs' },
    { label: 'À propos',         href: '#pourquoi' },
    { label: 'Contact',          href: '#contact' },
  ],
  en: [
    { label: 'Home',      href: '#accueil' },
    { label: 'Features',  href: '#fonctionnalites' },
    { label: 'Solutions', href: '#solutions' },
    { label: 'Security',  href: '#securite' },
    { label: 'Pricing',   href: '#tarifs' },
    { label: 'About',     href: '#pourquoi' },
    { label: 'Contact',   href: '#contact' },
  ],
};

// ─── Navigation — bouton CTA ─────────────────────────────────────────────────
export const NAV_DEMO_BTN = {
  fr: 'Demander une démo',
  en: 'Request a demo',
};

// ─── Hero ────────────────────────────────────────────────────────────────────
export const HERO = {
  fr: {
    tag:          'Business Operating System',
    title1:       'Run Your',
    title2:       'Business.',
    subtitle:     "Le logiciel de gestion assurance conçu par des experts du secteur. Cabinets de courtage, sociétés d'assistance, compagnies — une plateforme complète, bien au-delà du CRM, pensée pour votre réalité terrain.",
    ctaPrimary:   'Découvrir PitBoard',
    ctaSecondary: 'Demander une démonstration',
    stats: [
      { value: '100+', label: 'Fonctionnalités' },
      { value: '3',    label: 'Espaces métier' },
      { value: '24/7', label: 'Disponibilité' },
      { value: 'PWA',  label: 'Native multi-device' },
    ],
    trust: ['Hébergé en France', 'Conforme RGPD', 'Multi-tenant isolé', 'Disponible 24/7'],
    imgAlt: 'Équipe PitBoard en action',
    float: {
      statsValue:    '1 247',
      statsLabel:    'clients actifs gérés',
      statsTrend:    '+18% ce mois',
      activityTitle: 'Activité en temps réel',
      activity: [
        { text: 'Contrat signé — Cabinet Martin', time: '3 min' },
        { text: 'Devis #DEV-2412 accepté',         time: '12 min' },
        { text: 'Dossier SIN-0042 clos',            time: '1 h' },
      ],
    },
  },
  en: {
    tag:          'Business Operating System',
    title1:       'Run Your',
    title2:       'Business.',
    subtitle:     'Insurance management software built by industry experts. Brokerage firms, assistance companies, insurers — a complete platform, far beyond a CRM, designed for your real-world operations.',
    ctaPrimary:   'Discover PitBoard',
    ctaSecondary: 'Request a demo',
    stats: [
      { value: '100+', label: 'Features' },
      { value: '3',    label: 'Business spaces' },
      { value: '24/7', label: 'Availability' },
      { value: 'PWA',  label: 'Native multi-device' },
    ],
    trust: ['Hosted in France', 'GDPR Compliant', 'Isolated multi-tenant', 'Available 24/7'],
    imgAlt: 'PitBoard team in action',
    float: {
      statsValue:    '1,247',
      statsLabel:    'active clients managed',
      statsTrend:    '+18% this month',
      activityTitle: 'Real-time activity',
      activity: [
        { text: 'Contract signed — Cabinet Martin', time: '3 min' },
        { text: 'Quote #DEV-2412 accepted',          time: '12 min' },
        { text: 'File SIN-0042 closed',               time: '1 h' },
      ],
    },
  },
};

// ─── Hero Mockup ──────────────────────────────────────────────────────────────
export const PRODUCT_DEMO = {
  fr: {
    label:    'Aperçu produit',
    title:    "L'interface PitBoard.",
    subtitle: 'Pensée pour aller vite. Chaque information au bon endroit, au bon moment.',
    slides: [
      { id: 'dashboard',   label: 'Dashboard',    activeNav: 0 },
      { id: 'crm',         label: 'CRM Clients',  activeNav: 1 },
      { id: 'devis',       label: 'Hub Devis',    activeNav: 2 },
      { id: 'messagerie',  label: 'Messagerie',   activeNav: 3 },
      { id: 'ia',          label: 'IA',           activeNav: 6 },
      { id: 'commissions', label: 'Commissions',  activeNav: 6 },
      { id: 'builder',     label: 'Builder',      activeNav: 7 },
    ],
    prevLabel: 'Vue précédente',
    nextLabel: 'Vue suivante',
    navItems: [
      { label: 'Dashboard',   badge: null,    type: null },
      { label: 'CRM Clients', badge: '1 247', type: 'default' },
      { label: 'Hub Devis',   badge: '12',    type: 'default' },
      { label: 'Messagerie',  badge: '3',     type: 'red' },
      { label: 'Agenda',      badge: null,    type: null },
      { label: 'Documents',   badge: null,    type: null },
      { label: 'IA',          badge: null,    type: null },
      { label: 'Builder',     badge: null,    type: null },
    ],
    dashStats: [
      { v: '1 247', l: 'Clients actifs' },
      { v: '12',    l: 'Devis en cours' },
      { v: '24',    l: 'Tâches' },
      { v: '98%',   l: 'Satisfaction' },
    ],
    dashActivity: [
      { t: 'Contrat signé — Cabinet Martin', time: 'il y a 3 min',  c: '#10B981' },
      { t: 'Devis #DEV-2412 accepté',        time: 'il y a 12 min', c: '#0055A4' },
      { t: 'Dossier SIN-0042 clos',          time: 'il y a 1h',     c: '#94A3B8' },
    ],
    date:          'Lun. 5 août 2026',
    crmHeader:     ['Client', 'Type', 'Contrats', 'Statut'],
    crmFilters:    '1 247 clients — 3 filtres actifs',
    crmNewClient:  '+ Nouveau client',
    crmClients: [
      { nom: 'Cabinet Martin',    type: 'Courtier',   contrats: 4, statut: 'Actif',    color: '#10B981' },
      { nom: 'SAS Dupont & Fils', type: 'Assurance',  contrats: 2, statut: 'Actif',    color: '#10B981' },
      { nom: 'Assistance Pro 44', type: 'Assistance', contrats: 7, statut: 'En cours', color: '#F59E0B' },
      { nom: 'Groupe Leclerc',    type: 'Courtier',   contrats: 1, statut: 'Actif',    color: '#10B981' },
      { nom: 'Sud Courtage',      type: 'Assurance',  contrats: 3, statut: 'Inactif',  color: '#94A3B8' },
    ],
    devisStats: [
      { v: '12', l: 'En cours' },
      { v: '34', l: 'Acceptés' },
      { v: '8',  l: 'Refusés' },
    ],
    devis: [
      { ref: '#DEV-2415', client: 'Cabinet Martin',    montant: '2 400 €', statut: 'Accepté',  c: '#10B981', bg: '#F0FDF4' },
      { ref: '#DEV-2414', client: 'SAS Dupont',        montant: '890 €',   statut: 'En cours', c: '#F59E0B', bg: '#FFFBEB' },
      { ref: '#DEV-2413', client: 'Assistance Pro 44', montant: '5 200 €', statut: 'En cours', c: '#F59E0B', bg: '#FFFBEB' },
      { ref: '#DEV-2412', client: 'Groupe Leclerc',    montant: '1 100 €', statut: 'Accepté',  c: '#10B981', bg: '#F0FDF4' },
      { ref: '#DEV-2411', client: 'Sud Courtage',      montant: '740 €',   statut: 'Refusé',   c: '#EF4135', bg: '#FEF2F2' },
    ],
    msgTitle:  'Boîte de réception',
    msgUnread: '2 non lus',
    mails: [
      { from: 'Sophie Laurent', obj: 'Demande de devis complémentaire',   time: '09:42', unread: true  },
      { from: 'Thomas Rieux',   obj: 'Validation du contrat PRO-2024',     time: '08:15', unread: true  },
      { from: 'Admin ASAR',     obj: 'Rapport mensuel — juillet 2026',     time: 'Hier',  unread: false },
      { from: 'Pierre Dumont',  obj: 'Question sur la garantie dommages',  time: 'Hier',  unread: false },
      { from: 'Cabinet Martin', obj: 'Renouvellement contrat flotte auto', time: 'Lun.',  unread: false },
    ],
    iaLabel:     'Analyse documentaire',
    iaTitle:     'Analyse du bordereau — Cabinet Martin — Juillet 2026',
    iaStats: [
      { v: '€ 4 820', l: 'Total commissions' },
      { v: '12',      l: 'Contrats analysés' },
      { v: '100%',    l: 'Confiance' },
    ],
    iaAssistant: 'Assistant PitBoard IA',
    iaText:      'Le bordereau présente 12 lignes de commissions pour un total de <strong>4 820 €</strong>. Aucune anomalie détectée. Taux moyen : 8,4 %. Recommandation : renégocier le contrat n° 7 (taux inférieur au marché).',
    iaActions:   ['Exporter le rapport', 'Ajouter une note', 'Contacter le courtier'],
    // Commissions & Bordereaux IA
    commStats: [
      { v: '€ 14 670', l: 'Total commissions' },
      { v: '3',        l: 'Bordereaux analysés' },
      { v: '1',        l: 'Anomalie détectée' },
    ],
    commHeader: ['Réf.', 'Courtier', 'Montant', 'Statut IA'],
    bordereaux: [
      { ref: 'BRD-0142', courtier: 'Cabinet Martin',  montant: '4 820 €', statut: 'Vérifié',  c: '#10B981', bg: '#F0FDF4' },
      { ref: 'BRD-0141', courtier: 'SAS Dupont',      montant: '2 100 €', statut: 'Anomalie', c: '#EF4135', bg: '#FEF2F2' },
      { ref: 'BRD-0140', courtier: 'Groupe Leclerc',  montant: '3 450 €', statut: 'Vérifié',  c: '#10B981', bg: '#F0FDF4' },
      { ref: 'BRD-0139', courtier: 'Sud Courtage',    montant: '4 300 €', statut: 'En cours', c: '#F59E0B', bg: '#FFFBEB' },
    ],
    commAI: '1 anomalie sur <strong>BRD-0141</strong> : taux anormal (12,4 % vs 8,4 % attendu). Recommandation : vérifier le contrat SAS Dupont.',
    // PitBoard Builder
    builderTitle:    'PitBoard Builder',
    builderPreview:  'Aperçu',
    builderPublish:  'Publier',
    builderBlocks:   'Sections',
    builderStatus:   'Mise à jour il y a 2 min',
    builderUrl:      'pitboardsuite.com',
    blocks: ['Hero', 'Fonctionnalités', 'Tarifs', 'FAQ', 'Footer', 'Témoignages', 'Contact'],
    floatLeft:  [
      { value: '1 247', label: 'Clients actifs',  color: '#10B981' },
      { value: '34',    label: 'Devis acceptés',  color: '#0055A4' },
    ],
    floatRight: [
      { value: '98%',     label: 'Satisfaction',  color: '#F59E0B' },
      { value: 'IA',      label: 'Assistants IA', color: '#8B5CF6' },
    ],
  },
  en: {
    label:    'Product overview',
    title:    'The PitBoard interface.',
    subtitle: 'Built for speed. Every piece of information, in the right place, at the right time.',
    slides: [
      { id: 'dashboard',   label: 'Dashboard',   activeNav: 0 },
      { id: 'crm',         label: 'CRM Clients', activeNav: 1 },
      { id: 'devis',       label: 'Quote Hub',   activeNav: 2 },
      { id: 'messagerie',  label: 'Inbox',       activeNav: 3 },
      { id: 'ia',          label: 'AI',          activeNav: 6 },
      { id: 'commissions', label: 'Commissions', activeNav: 6 },
      { id: 'builder',     label: 'Builder',     activeNav: 7 },
    ],
    prevLabel: 'Previous view',
    nextLabel: 'Next view',
    navItems: [
      { label: 'Dashboard',   badge: null,    type: null },
      { label: 'CRM Clients', badge: '1 247', type: 'default' },
      { label: 'Quote Hub',   badge: '12',    type: 'default' },
      { label: 'Inbox',       badge: '3',     type: 'red' },
      { label: 'Calendar',    badge: null,    type: null },
      { label: 'Documents',   badge: null,    type: null },
      { label: 'AI',          badge: null,    type: null },
      { label: 'Builder',     badge: null,    type: null },
    ],
    dashStats: [
      { v: '1 247', l: 'Active clients' },
      { v: '12',    l: 'Ongoing quotes' },
      { v: '24',    l: 'Tasks' },
      { v: '98%',   l: 'Satisfaction' },
    ],
    dashActivity: [
      { t: 'Contract signed — Cabinet Martin', time: '3 min ago',  c: '#10B981' },
      { t: 'Quote #DEV-2412 accepted',         time: '12 min ago', c: '#0055A4' },
      { t: 'File SIN-0042 closed',             time: '1h ago',     c: '#94A3B8' },
    ],
    date:          'Mon. Aug 5, 2026',
    crmHeader:     ['Client', 'Type', 'Contracts', 'Status'],
    crmFilters:    '1 247 clients — 3 active filters',
    crmNewClient:  '+ New client',
    crmClients: [
      { nom: 'Cabinet Martin',    type: 'Broker',     contrats: 4, statut: 'Active',   color: '#10B981' },
      { nom: 'SAS Dupont & Fils', type: 'Insurance',  contrats: 2, statut: 'Active',   color: '#10B981' },
      { nom: 'Assistance Pro 44', type: 'Assistance', contrats: 7, statut: 'Ongoing',  color: '#F59E0B' },
      { nom: 'Groupe Leclerc',    type: 'Broker',     contrats: 1, statut: 'Active',   color: '#10B981' },
      { nom: 'Sud Courtage',      type: 'Insurance',  contrats: 3, statut: 'Inactive', color: '#94A3B8' },
    ],
    devisStats: [
      { v: '12', l: 'Ongoing' },
      { v: '34', l: 'Accepted' },
      { v: '8',  l: 'Rejected' },
    ],
    devis: [
      { ref: '#DEV-2415', client: 'Cabinet Martin',    montant: '€2,400', statut: 'Accepted', c: '#10B981', bg: '#F0FDF4' },
      { ref: '#DEV-2414', client: 'SAS Dupont',        montant: '€890',   statut: 'Ongoing',  c: '#F59E0B', bg: '#FFFBEB' },
      { ref: '#DEV-2413', client: 'Assistance Pro 44', montant: '€5,200', statut: 'Ongoing',  c: '#F59E0B', bg: '#FFFBEB' },
      { ref: '#DEV-2412', client: 'Groupe Leclerc',    montant: '€1,100', statut: 'Accepted', c: '#10B981', bg: '#F0FDF4' },
      { ref: '#DEV-2411', client: 'Sud Courtage',      montant: '€740',   statut: 'Rejected', c: '#EF4135', bg: '#FEF2F2' },
    ],
    msgTitle:  'Inbox',
    msgUnread: '2 unread',
    mails: [
      { from: 'Sophie Laurent', obj: 'Additional quote request',       time: '09:42', unread: true  },
      { from: 'Thomas Rieux',   obj: 'Contract PRO-2024 validation',   time: '08:15', unread: true  },
      { from: 'Admin ASAR',     obj: 'Monthly report — July 2026',     time: 'Yest.', unread: false },
      { from: 'Pierre Dumont',  obj: 'Question about damage coverage', time: 'Yest.', unread: false },
      { from: 'Cabinet Martin', obj: 'Auto fleet contract renewal',    time: 'Mon.',  unread: false },
    ],
    iaLabel:     'Document analysis',
    iaTitle:     'Commission statement — Cabinet Martin — July 2026',
    iaStats: [
      { v: '€4,820', l: 'Total commissions' },
      { v: '12',     l: 'Contracts analyzed' },
      { v: '100%',   l: 'Confidence' },
    ],
    iaAssistant: 'PitBoard AI Assistant',
    iaText:      'The statement shows 12 commission lines totaling <strong>€4,820</strong>. No anomalies detected. Average rate: 8.4%. Recommendation: renegotiate contract n°7 (below market rate).',
    iaActions:   ['Export report', 'Add a note', 'Contact broker'],
    // Commissions & Bordereau AI
    commStats: [
      { v: '€ 14,670', l: 'Total commissions' },
      { v: '3',        l: 'Statements analyzed' },
      { v: '1',        l: 'Anomaly detected' },
    ],
    commHeader: ['Ref.', 'Broker', 'Amount', 'AI Status'],
    bordereaux: [
      { ref: 'BRD-0142', courtier: 'Cabinet Martin', montant: '€4,820', statut: 'Verified', c: '#10B981', bg: '#F0FDF4' },
      { ref: 'BRD-0141', courtier: 'SAS Dupont',     montant: '€2,100', statut: 'Anomaly',  c: '#EF4135', bg: '#FEF2F2' },
      { ref: 'BRD-0140', courtier: 'Groupe Leclerc', montant: '€3,450', statut: 'Verified', c: '#10B981', bg: '#F0FDF4' },
      { ref: 'BRD-0139', courtier: 'Sud Courtage',   montant: '€4,300', statut: 'Ongoing',  c: '#F59E0B', bg: '#FFFBEB' },
    ],
    commAI: '1 anomaly on <strong>BRD-0141</strong>: abnormal rate (12.4% vs 8.4% expected). Recommendation: verify SAS Dupont contract.',
    // PitBoard Builder
    builderTitle:   'PitBoard Builder',
    builderPreview: 'Preview',
    builderPublish: 'Publish',
    builderBlocks:  'Sections',
    builderStatus:  'Updated 2 min ago',
    builderUrl:     'pitboardsuite.com',
    blocks: ['Hero', 'Features', 'Pricing', 'FAQ', 'Footer', 'Testimonials', 'Contact'],
    floatLeft:  [
      { value: '1 247', label: 'Active clients',   color: '#10B981' },
      { value: '34',    label: 'Accepted quotes',  color: '#0055A4' },
    ],
    floatRight: [
      { value: '98%', label: 'Satisfaction',  color: '#F59E0B' },
      { value: 'AI',  label: 'AI Assistants', color: '#8B5CF6' },
    ],
  },
};

// ─── Features Bento ───────────────────────────────────────────────────────────
export const FEATURES = {
  fr: [
    { id: 'crm',              span: 'pb-col-7', label: 'CRM',           title: 'Pilotez vos relations client',      desc: "Clients, courtiers, compagnies. Un espace unifié pour gérer l'ensemble de vos contacts, contrats et communications." },
    { id: 'documents',        span: 'pb-col-5', label: 'Documents',      title: 'Documents centralisés',             desc: "Dépôt, partage, archivage sécurisé. Tous vos documents accessibles depuis n'importe où." },
    { id: 'ia',               span: 'pb-col-4', label: 'IA intégrée',    title: 'Intelligence artificielle native',  desc: 'Analyse documentaire, rédaction assistée, aide à la décision.' },
    { id: 'messagerie',       span: 'pb-col-4', label: 'Messagerie',     title: 'Communication unifiée',             desc: 'Email, chat interne, notifications. Tous vos échanges au même endroit.' },
    { id: 'agenda',           span: 'pb-col-4', label: 'Agenda',         title: 'Planification simplifiée',          desc: 'RDV, rappels, prise de rendez-vous en ligne par vos clients.' },
    { id: 'signature',        span: 'pb-col-5', label: 'Signature',      title: 'Signature électronique',            desc: 'Signez vos documents directement dans PitBoard. Valeur légale garantie.' },
    { id: 'automatisations',  span: 'pb-col-4', label: 'Automatisations',title: 'Workflows intelligents',            desc: "Automatisez les tâches répétitives. Concentrez-vous sur l'essentiel." },
    { id: 'business-logic',   span: 'pb-col-3', label: 'Business Logic', title: 'Logique métier intégrée',           desc: "Adaptée à votre secteur d'activité." },
  ],
  en: [
    { id: 'crm',              span: 'pb-col-7', label: 'CRM',           title: 'Manage your client relationships',  desc: 'Clients, brokers, insurers. A unified space to manage all your contacts, contracts and communications.' },
    { id: 'documents',        span: 'pb-col-5', label: 'Documents',      title: 'Centralized documents',             desc: 'Upload, share, secure archiving. All your documents accessible from anywhere.' },
    { id: 'ia',               span: 'pb-col-4', label: 'AI',             title: 'Native artificial intelligence',    desc: 'Document analysis, assisted writing, decision support.' },
    { id: 'messagerie',       span: 'pb-col-4', label: 'Messaging',      title: 'Unified communication',             desc: 'Email, internal chat, notifications. All your exchanges in one place.' },
    { id: 'agenda',           span: 'pb-col-4', label: 'Calendar',       title: 'Simplified scheduling',             desc: 'Appointments, reminders, online booking for your clients.' },
    { id: 'signature',        span: 'pb-col-5', label: 'Signature',      title: 'Electronic signature',              desc: 'Sign your documents directly in PitBoard. Legal value guaranteed.' },
    { id: 'automatisations',  span: 'pb-col-4', label: 'Automation',     title: 'Smart workflows',                   desc: 'Automate repetitive tasks. Focus on what matters.' },
    { id: 'business-logic',   span: 'pb-col-3', label: 'Business Logic', title: 'Integrated business logic',         desc: 'Adapted to your industry.' },
  ],
};

// ─── Features — en-tête de section ────────────────────────────────────────────
export const FEATURES_HEADER = {
  fr: {
    label: 'Plateforme',
    title: 'Une seule plateforme.\nTout fonctionne ensemble.',
    sub:   'CRM, Documents, IA, Messagerie, Agenda, Signature, Automatisations, Business Logic. Chaque module est conçu pour fonctionner de manière fluide avec les autres.',
    ariaLabel: 'Modules PitBoard — architecture modulaire',
  },
  en: {
    label: 'Platform',
    title: 'One platform.\nEverything works together.',
    sub:   'CRM, Documents, AI, Messaging, Calendar, Signature, Automations, Business Logic. Each module is designed to work seamlessly with the others.',
    ariaLabel: 'PitBoard modules — modular architecture',
  },
};

// ─── Industries ───────────────────────────────────────────────────────────────
export const INDUSTRIES = {
  fr: {
    header: {
      label: 'Solutions métier',
      title: 'Pensé pour les métiers.',
      sub:   "Architecture ouverte, logique métier intégrée. PitBoard s'adapte à votre secteur.",
    },
    visual: {
      courtage:   { label: 'Bordereaux & CRM',      statuses: ['Actif', 'En cours', 'Clos'] },
      assistance: { label: 'Dossiers & Facturation', statuses: ['Actif', 'En cours', 'Clos'] },
      assurance:  { label: 'Devis & Souscription',   statuses: ['Actif', 'En cours', 'Clos'] },
    },
    ctaLabel: 'En savoir plus',
    courtage: {
      label:    'Courtier',
      headline: 'Logiciel de gestion pour cabinets de courtage',
      desc:     "Gérez vos clients, votre portefeuille de contrats et vos commissions depuis un seul outil. PitBoard automatise vos bordereaux et centralise vos échanges avec les compagnies d'assurance.",
      features: [
        'Gestion des contrats et garanties',
        'Bordereaux de commissions automatisés',
        'Espace courtier sécurisé',
        'CRM clients dédié',
        'Documents et devis intégrés',
        'Suivi des renouvellements',
      ],
      color: '#0055A4',
    },
    assistance: {
      label:    'Assistance',
      headline: "Logiciel de gestion pour sociétés d'assistance",
      desc:     "Pilotez vos dossiers d'assistance, gérez vos prestataires et suivez la facturation de bout en bout. PitBoard couvre le cycle complet du sinistre à la clôture.",
      features: [
        'Gestion des dossiers de sinistres',
        'Espace prestataire sécurisé',
        'Facturation automatique',
        'Suivi des commandes de services',
        'Documents partagés en temps réel',
        'Reporting et statistiques',
      ],
      color: '#0A192F',
    },
    assurance: {
      label:    'Assurance Compagnie',
      headline: "Logiciel de gestion pour compagnies et cabinets d'assurance",
      desc:     "Du devis à la souscription, gérez le cycle de vie complet de vos contrats. PitBoard offre une vue 360° de vos clients et automatise vos processus de souscription.",
      features: [
        'Hub de devis et souscription',
        'Gestion des sinistres',
        'Espace client digital',
        'Automatisation des relances',
        'Tableau de bord décisionnel',
        'Intégration email native',
      ],
      color: '#1E3A5F',
    },
  },
  en: {
    header: {
      label: 'Business solutions',
      title: 'Built for your industry.',
      sub:   'Open architecture, integrated business logic. PitBoard adapts to your sector.',
    },
    visual: {
      courtage:   { label: 'Bordereau & CRM',       statuses: ['Active', 'In progress', 'Closed'] },
      assistance: { label: 'Files & Billing',        statuses: ['Active', 'In progress', 'Closed'] },
      assurance:  { label: 'Quotes & Underwriting',  statuses: ['Active', 'In progress', 'Closed'] },
    },
    ctaLabel: 'Learn more',
    courtage: {
      label:    'Broker',
      headline: 'Insurance management software for brokerage firms',
      desc:     'Manage your clients, contract portfolio and commissions from a single tool. PitBoard automates your bordereau statements and centralizes communications with insurance companies.',
      features: [
        'Contract and coverage management',
        'Automated commission statements',
        'Secure broker portal',
        'Dedicated client CRM',
        'Integrated documents and quotes',
        'Renewal tracking',
      ],
      color: '#0055A4',
    },
    assistance: {
      label:    'Assistance',
      headline: 'Management software for assistance companies',
      desc:     'Manage your assistance files, providers and billing from end to end. PitBoard covers the complete cycle from claim to closure.',
      features: [
        'Claim file management',
        'Secure provider portal',
        'Automated billing',
        'Service order tracking',
        'Real-time document sharing',
        'Reporting and analytics',
      ],
      color: '#0A192F',
    },
    assurance: {
      label:    'Insurance',
      headline: 'Management software for insurance companies and brokers',
      desc:     'From quote to underwriting, manage the complete lifecycle of your contracts. PitBoard provides a 360° view of your clients and automates your underwriting processes.',
      features: [
        'Quote and underwriting hub',
        'Claims management',
        'Digital client portal',
        'Automated follow-ups',
        'Decision-making dashboard',
        'Native email integration',
      ],
      color: '#1E3A5F',
    },
  },
};

// ─── AI Features ──────────────────────────────────────────────────────────────
export const AI_FEATURES = {
  fr: [
    { num: '01', title: 'Lecture documentaire',  desc: "Analyse automatique de vos contrats, bordereaux et pièces justificatives. PitBoard extrait les données clés en quelques secondes." },
    { num: '02', title: 'Lecture de bordereaux', desc: "Importez vos bordereaux de commissions. L'IA identifie et réconcilie les données automatiquement." },
    { num: '03', title: 'Rédaction automatique', desc: "Générez des emails et réponses professionnelles en un clic depuis votre messagerie intégrée." },
    { num: '04', title: 'Assistant métier',      desc: "Posez vos questions en langage naturel. PitBoard répond en tenant compte de votre contexte métier." },
    { num: '05', title: 'Aide à la décision',    desc: "Analysez vos données, identifiez les opportunités et anticipez les risques grâce à l'IA." },
    { num: '06', title: 'Automatisation',        desc: "Définissez vos règles métier une seule fois. PitBoard les applique automatiquement à chaque nouveau cas." },
  ],
  en: [
    { num: '01', title: 'Document reading',   desc: 'Automatic analysis of your contracts, bordereau statements and supporting documents. PitBoard extracts key data in seconds.' },
    { num: '02', title: 'Bordereau reading',  desc: 'Import your commission statements. AI identifies and reconciles data automatically.' },
    { num: '03', title: 'Automatic drafting', desc: 'Generate professional emails and responses in one click from your integrated messaging.' },
    { num: '04', title: 'Business assistant', desc: 'Ask questions in natural language. PitBoard responds taking your business context into account.' },
    { num: '05', title: 'Decision support',   desc: 'Analyze your data, identify opportunities and anticipate risks with AI.' },
    { num: '06', title: 'Automation',         desc: 'Define your business rules once. PitBoard applies them automatically to each new case.' },
  ],
};

// ─── AI Section — en-tête + CTA ───────────────────────────────────────────────
export const AI_SECTION = {
  fr: {
    label:       'Intelligence artificielle',
    title:       'IA intégrée.\nPas un module optionnel.',
    sub:         "PitBoard embarque l'IA directement dans vos flux de travail. Pas de copier-coller, pas d'outil externe. L'intelligence artificielle est là où vous en avez besoin.",
    compatText:  'Compatible avec OpenAI, Google Gemini et Anthropic Claude.',
    customText:  'PitBoard développe des solutions IA sur mesure pour votre métier.',
    learnMore:   'En savoir plus',
  },
  en: {
    label:       'Artificial intelligence',
    title:       'AI built in.\nNot an optional module.',
    sub:         'PitBoard embeds AI directly into your workflows. No copy-pasting, no external tool. Artificial intelligence is where you need it.',
    compatText:  'Compatible with OpenAI, Google Gemini and Anthropic Claude.',
    customText:  'PitBoard builds custom AI solutions for your business.',
    learnMore:   'Learn more',
  },
};

// ─── Security ─────────────────────────────────────────────────────────────────
export const SECURITY_FEATURES = {
  fr: [
    { icon: 'ShieldCheck', title: 'Double authentification (2FA)', desc: "Protégez chaque connexion avec un second facteur d'authentification. Aucun accès non autorisé ne peut passer." },
    { icon: 'FileText',    title: 'Journalisation complète',       desc: "Toutes les actions sont tracées avec horodatage. Idéal pour les audits et la conformité réglementaire." },
    { icon: 'Lock',        title: 'Permissions granulaires',       desc: "Contrôlez précisément ce que chaque utilisateur peut voir et faire. Des droits adaptés à chaque rôle." },
    { icon: 'Database',    title: 'Sauvegardes automatiques',      desc: "Vos données sont sauvegardées en continu. Restauration en cas de besoin, sans perte d'information." },
  ],
  en: [
    { icon: 'ShieldCheck', title: 'Two-factor authentication (2FA)', desc: 'Protect every login with a second authentication factor. No unauthorized access can get through.' },
    { icon: 'FileText',    title: 'Complete audit trail',            desc: 'All actions are tracked with timestamps. Ideal for audits and regulatory compliance.' },
    { icon: 'Lock',        title: 'Granular permissions',            desc: 'Control precisely what each user can see and do. Rights adapted to each role.' },
    { icon: 'Database',    title: 'Automatic backups',               desc: 'Your data is continuously backed up. Restore when needed, without loss of information.' },
  ],
};

// ─── Security — en-tête de section ────────────────────────────────────────────
export const SECURITY_HEADER = {
  fr: {
    label:  'Sécurité',
    title:  'Conçu pour\nla confiance.',
    sub:    'Chaque donnée est protégée. Chaque action est tracée. PitBoard applique les standards de sécurité les plus élevés pour vous et vos clients.',
    badges: ['Multi-tenant isolé', 'RGPD', 'Journalisation', 'Chiffrement'],
  },
  en: {
    label:  'Security',
    title:  'Built for\ntrust.',
    sub:    'Every piece of data is protected. Every action is tracked. PitBoard applies the highest security standards for you and your clients.',
    badges: ['Isolated multi-tenant', 'GDPR', 'Audit trail', 'Encryption'],
  },
};

// ─── Web Apps ─────────────────────────────────────────────────────────────────
export const WEB_APPS = {
  fr: [
    { icon: 'Monitor',    title: 'Desktop',  desc: 'Interface complète, optimisée pour les grands écrans et la productivité.' },
    { icon: 'Tablet',     title: 'Tablette', desc: 'Toutes les fonctionnalités adaptées pour une utilisation tactile.' },
    { icon: 'Smartphone', title: 'Mobile',   desc: "Application native installable, conçue pour une utilisation en déplacement." },
    { icon: 'Globe',      title: 'PWA',      desc: 'Une seule installation, disponible partout, même sans connexion internet.' },
  ],
  en: [
    { icon: 'Monitor',    title: 'Desktop', desc: 'Full interface optimized for large screens and productivity.' },
    { icon: 'Tablet',     title: 'Tablet',  desc: 'All features adapted for touch use.' },
    { icon: 'Smartphone', title: 'Mobile',  desc: 'Installable native app, designed for use on the go.' },
    { icon: 'Globe',      title: 'PWA',     desc: 'One installation, available everywhere, even without internet.' },
  ],
};

// ─── WebApps — en-tête de section ─────────────────────────────────────────────
export const WEBAPPS_HEADER = {
  fr: {
    label:       'Multi-plateforme',
    title:       'Une seule installation.\nTous vos appareils.',
    sub:         "PitBoard Suite est une Progressive Web App native. Installez-la une fois, utilisez-la partout — sans App Store, sans contrainte.",
    bannerTitle: 'Disponible sur tous les navigateurs modernes.',
    bannerSub:   "Chrome, Safari, Edge, Firefox. Aucune dépendance au système d'exploitation.",
  },
  en: {
    label:       'Multi-platform',
    title:       'One installation.\nAll your devices.',
    sub:         'PitBoard Suite is a native Progressive Web App. Install it once, use it everywhere — no App Store, no constraints.',
    bannerTitle: 'Available on all modern browsers.',
    bannerSub:   'Chrome, Safari, Edge, Firefox. No operating system dependency.',
  },
};

// ─── Performance ──────────────────────────────────────────────────────────────
export const PERF_STATS = {
  fr: [
    { value: 'SPA',     label: 'Architecture',       sub: 'Navigation instantanée' },
    { value: 'FastAPI', label: 'Backend Python',     sub: 'Ultra-performant' },
    { value: 'MongoDB', label: 'Base de données',    sub: 'Flexible et scalable' },
    { value: 'PWA',     label: 'Progressive Web App',sub: 'Installable partout' },
  ],
  en: [
    { value: 'SPA',     label: 'Architecture',        sub: 'Instant navigation' },
    { value: 'FastAPI', label: 'Python Backend',      sub: 'Ultra-performant' },
    { value: 'MongoDB', label: 'Database',            sub: 'Flexible and scalable' },
    { value: 'PWA',     label: 'Progressive Web App', sub: 'Installable everywhere' },
  ],
};

// ─── Performance — en-tête ────────────────────────────────────────────────────
export const PERFORMANCE_HEADER = {
  fr: {
    label: 'Performances',
    title: 'Rapide par conception.',
    sub:   "Architecture moderne pensée pour la vitesse. PitBoard répond en millisecondes, même avec des milliers d'utilisateurs simultanés.",
  },
  en: {
    label: 'Performance',
    title: 'Fast by design.',
    sub:   'Modern architecture built for speed. PitBoard responds in milliseconds, even with thousands of concurrent users.',
  },
};

// ─── Why PitBoard ─────────────────────────────────────────────────────────────
export const WHY_PITBOARD = {
  fr: [
    { num: '01', title: 'Confiance',  desc: "Architecture sécurisée, données isolées par tenant, journalisation complète. Vous avez le contrôle total de vos informations." },
    { num: '02', title: 'Pilotage',   desc: "Tableau de bord en temps réel. Toutes les métriques de votre activité, centralisées et actionnables en un coup d'œil." },
    { num: '03', title: 'Simplicité', desc: "Interface épurée, pensée pour vos métiers. Prise en main rapide, formation minimale, adoption maximale." },
    { num: '04', title: 'Puissance',  desc: "Plus de 100 fonctionnalités, IA native, automatisations avancées. La puissance d'un grand logiciel, l'agilité d'une startup." },
  ],
  en: [
    { num: '01', title: 'Trust',       desc: 'Secure architecture, isolated per-tenant data, complete audit trail. You have total control over your information.' },
    { num: '02', title: 'Control',     desc: 'Real-time dashboard. All your business metrics, centralized and actionable at a glance.' },
    { num: '03', title: 'Simplicity',  desc: 'Clean interface designed for your industry. Quick onboarding, minimal training, maximum adoption.' },
    { num: '04', title: 'Power',       desc: 'Over 100 features, native AI, advanced automations. The power of enterprise software, the agility of a startup.' },
  ],
};

// ─── Why — en-tête ────────────────────────────────────────────────────────────
export const WHY_HEADER = {
  fr: {
    label: 'Pourquoi PitBoard',
    title: "Ce n'est pas seulement\nun logiciel.",
    sub:   "C'est le centre de pilotage de votre entreprise. Conçu pour durer 15 ans. Pensé pour les dirigeants qui veulent garder le contrôle.",
  },
  en: {
    label: 'Why PitBoard',
    title: "It's not just\na software.",
    sub:   "It's the control center of your business. Built to last 15 years. Designed for leaders who want to stay in control.",
  },
};

// ─── Testimonials ─────────────────────────────────────────────────────────────
export const TESTIMONIALS = {
  fr: [
    {
      quote:   "PitBoard Suite a transformé notre gestion des dossiers d'assistance. La centralisation des données et les automatisations nous permettent de gagner en efficacité opérationnelle chaque jour.",
      company: 'ASAR CSG',
      role:    "Société d'Assistance",
      logo:    'asar',
    },
    {
      quote:   'Avec PitBoard Suite, notre réseau international dispose enfin d\'une plateforme unifiée. Dossiers, communication, facturation — tout est centralisé et accessible depuis n\'importe où.',
      company: 'dna-24.com',
      role:    "Réseau d'Assistance International",
      logo:    'dna',
    },
  ],
  en: [
    {
      quote:   'PitBoard Suite has transformed our assistance file management. Data centralization and automations help us gain operational efficiency every day.',
      company: 'ASAR CSG',
      role:    'Assistance Company',
      logo:    'asar',
    },
    {
      quote:   "With PitBoard Suite, our international network finally has a unified platform. Files, communication, billing — everything is centralized and accessible from anywhere.",
      company: 'dna-24.com',
      role:    'International Assistance Network',
      logo:    'dna',
    },
  ],
};

// ─── Testimonials — en-tête ───────────────────────────────────────────────────
export const TESTIMONIALS_HEADER = {
  fr: {
    label: 'Références clients',
    title: 'Ils nous font confiance.',
    sub:   "Des sociétés d'assistance et des réseaux de services s'appuient sur PitBoard Suite pour piloter leur activité au quotidien.",
  },
  en: {
    label: 'Client references',
    title: 'They trust us.',
    sub:   'Assistance companies and service networks rely on PitBoard Suite to run their operations daily.',
  },
};

// ─── FAQ ─────────────────────────────────────────────────────────────────────
export const FAQ_ITEMS = {
  fr: [
    { q: "PitBoard Suite est-il un CRM assurance ?",       a: "PitBoard va bien au-delà d'un CRM classique. C'est un véritable ERP assurance : CRM courtier, gestion des contrats, messagerie intégrée, facturation, agenda et intelligence artificielle dans une seule plateforme. Un logiciel de gestion complet pour courtiers, assisteurs et compagnies — pas seulement un outil de contacts." },
    { q: "Qu'est-ce que PitBoard Suite ?",                 a: "PitBoard Suite est un Business Operating System conçu pour les cabinets de courtage, d'assurance et d'assistance. Il centralise CRM, documents, messagerie, agenda, facturation et IA dans une seule plateforme." },
    { q: "PitBoard est-il adapté à mon secteur ?",         a: "PitBoard est conçu en priorité pour le courtage, l'assistance et l'assurance, mais son architecture ouverte lui permet de s'adapter à d'autres secteurs nécessitant une gestion avancée des clients et des documents." },
    { q: "Comment fonctionne la sécurité des données ?",   a: "Chaque client dispose d'un environnement isolé (multi-tenant). Les données sont sécurisées, toutes les actions sont journalisées, et la double authentification (2FA) est disponible pour tous les comptes." },
    { q: "Est-ce que PitBoard fonctionne sur mobile ?",    a: "Oui. PitBoard Suite est une Progressive Web App (PWA) installable sur mobile, tablette et desktop. Une seule installation, tous les appareils." },
    { q: "Quelles intégrations sont disponibles ?",        a: "PitBoard intègre nativement la messagerie email (IMAP/SMTP), les notifications push, et plusieurs modèles d'IA (OpenAI, Google Gemini, Claude). D'autres intégrations sont en cours de développement." },
    { q: "Comment demander une démonstration ?",           a: "Contactez-nous à cockpit@pitboardsuite.com. Notre équipe vous répondra dans les 24 heures pour organiser une démonstration personnalisée." },
    { q: "PitBoard est-il hébergé en France ?",            a: "Oui. PitBoard Suite est déployé sur des serveurs localisés en Europe, conformément au RGPD. Vous gardez la maîtrise complète de vos données." },
    { q: "Existe-t-il une période d'essai ?",              a: "Oui. Contactez-nous pour organiser une démonstration et discuter des modalités d'accès à une période d'essai adaptée à votre activité." },
  ],
  en: [
    { q: "Is PitBoard Suite just a CRM?",                  a: "PitBoard goes far beyond a traditional CRM. It's a true insurance ERP: broker CRM, contract management, integrated messaging, billing, calendar and artificial intelligence in a single platform. A complete management system for brokers, assistance companies and insurers — not just a contact management tool." },
    { q: "What is PitBoard Suite?",                        a: "PitBoard Suite is a Business Operating System designed for brokerage firms, insurance and assistance companies. It centralizes CRM, documents, messaging, calendar, billing and AI in a single platform." },
    { q: "Is PitBoard suited to my industry?",             a: "PitBoard is primarily designed for brokerage, assistance and insurance, but its open architecture allows it to adapt to other sectors requiring advanced client and document management." },
    { q: "How does data security work?",                   a: "Each client has an isolated environment (multi-tenant). Data is secured, all actions are logged, and two-factor authentication (2FA) is available for all accounts." },
    { q: "Does PitBoard work on mobile?",                  a: "Yes. PitBoard Suite is a Progressive Web App (PWA) installable on mobile, tablet and desktop. One installation, all your devices." },
    { q: "What integrations are available?",               a: "PitBoard natively integrates email messaging (IMAP/SMTP), push notifications, and several AI models (OpenAI, Google Gemini, Claude). More integrations are in development." },
    { q: "How do I request a demo?",                       a: "Contact us at cockpit@pitboardsuite.com. Our team will respond within 24 hours to organize a personalized demonstration." },
    { q: "Is PitBoard hosted in France?",                  a: "Yes. PitBoard Suite is deployed on servers located in Europe, compliant with GDPR. You retain full control over your data." },
    { q: "Is there a trial period?",                       a: "Yes. Contact us to organize a demo and discuss the terms of access to a trial period adapted to your business." },
  ],
};

// ─── FAQ — en-tête ────────────────────────────────────────────────────────────
export const FAQ_HEADER = {
  fr: {
    label:      'FAQ',
    title:      'Questions fréquentes.',
    subText:    'Une question non couverte ici ?',
    contactBtn: 'Contactez-nous',
  },
  en: {
    label:      'FAQ',
    title:      'Frequently asked questions.',
    subText:    'A question not covered here?',
    contactBtn: 'Contact us',
  },
};

// ─── Contact section ──────────────────────────────────────────────────────────
export const CONTACT_SECTION = {
  fr: {
    label:     'Contact',
    title:     'Prêt à piloter\nvotre activité ?',
    sub:       "Prenez 30 minutes avec notre équipe. Nous vous montrons comment PitBoard Suite s'adapte à votre métier et transforme votre quotidien.",
    trust:     ['Démo personnalisée à votre secteur', 'Réponse sous 24h', 'Sans engagement'],
    hint:      'Une démonstration gratuite, sans engagement.',
    btn:       'Demander une démonstration',
  },
  en: {
    label:     'Contact',
    title:     'Ready to run\nyour business?',
    sub:       'Spend 30 minutes with our team. We show you how PitBoard Suite adapts to your industry and transforms your daily operations.',
    trust:     ['Demo tailored to your industry', 'Response within 24h', 'No commitment'],
    hint:      'A free demonstration, no commitment.',
    btn:       'Request a demonstration',
  },
};

// ─── Pricing section ──────────────────────────────────────────────────────────
export const PRICING_SECTION = {
  fr: {
    label: 'Tarifs',
    title: 'Tarif sur mesure.\nSans surprise.',
    desc:  "PitBoard ne propose pas de grilles tarifaires fixes. Chaque organisation est différente — votre tarif l'est aussi. Nous construisons une offre ajustée à votre taille, votre secteur et vos modules activés.",
    cta:   "Prendre contact avec l'équipe",
    avantages: [
      { iconKey: 'Building2', title: 'Adapté à votre métier',       desc: "Courtier, assisteur ou compagnie — votre tarif reflète vos modules activés, vos utilisateurs et votre volumétrie réelle." },
      { iconKey: 'Zap',       title: 'Mise en production incluse',   desc: "Accompagnement à l'onboarding, paramétrage métier, formation équipe. Pas de frais cachés, pas de surprise à l'activation." },
      { iconKey: 'Users',     title: 'Interlocuteur dédié',          desc: "Un chargé de compte unique de la démo à la production. Vous avancez vite, avec quelqu'un qui connaît votre secteur." },
    ],
    modal: {
      title:         'Parlons de votre projet',
      labelNom:      'Nom',
      labelSociete:  'Société',
      labelEmail:    'Email',
      labelTel:      'Téléphone',
      labelSecteur:  'Secteur',
      labelMessage:  'Message',
      phNom:         'Jean Dupont',
      phSociete:     'Cabinet Dupont & Associés',
      phEmail:       'jean@exemple.fr',
      phTel:         '+33 6 00 00 00 00',
      phMessage:     'Décrivez votre contexte, votre équipe, vos besoins…',
      sectors:       ['Assurance Compagnie', 'Courtier', 'Assistance', 'Autre'],
      sectorPh:      'Choisir votre secteur…',
      submit:        'Envoyer la demande',
      legal:         'Réponse garantie sous 24h ouvrées. Aucun engagement.',
      successMsg:    "Votre client email s'est ouvert avec les informations pré-remplies.\nEnvoyez le message à cockpit@pitboardsuite.com pour finaliser.",
      closeBtn:      'Fermer',
      ariaLabel:     'Prise de contact tarif',
      subjectPrefix: 'Demande tarif',
      bodyLines: {
        nom: 'Nom', societe: 'Société', email: 'Email', tel: 'Téléphone', secteur: 'Secteur', message: 'Message',
      },
    },
  },
  en: {
    label: 'Pricing',
    title: 'Custom pricing.\nNo surprises.',
    desc:  "PitBoard does not offer fixed pricing plans. Every organization is different — your pricing is too. We build an offer tailored to your size, industry and activated modules.",
    cta:   'Talk to the team',
    avantages: [
      { iconKey: 'Building2', title: 'Tailored to your industry',  desc: "Broker, assistance company or insurer — your price reflects your activated modules, users and actual volume." },
      { iconKey: 'Zap',       title: 'Production included',        desc: "Onboarding support, business configuration, team training. No hidden fees, no surprises at activation." },
      { iconKey: 'Users',     title: 'Dedicated contact',          desc: "A single account manager from demo to production. Move fast, with someone who knows your industry." },
    ],
    modal: {
      title:         "Let's talk about your project",
      labelNom:      'Name',
      labelSociete:  'Company',
      labelEmail:    'Email',
      labelTel:      'Phone',
      labelSecteur:  'Industry',
      labelMessage:  'Message',
      phNom:         'John Smith',
      phSociete:     'Smith & Associates',
      phEmail:       'john@example.com',
      phTel:         '+44 7700 900000',
      phMessage:     'Describe your context, your team, your needs…',
      sectors:       ['Insurance Company', 'Broker', 'Assistance', 'Other'],
      sectorPh:      'Choose your industry…',
      submit:        'Send request',
      legal:         'Response guaranteed within 24 business hours. No commitment.',
      successMsg:    "Your email client has opened with pre-filled information.\nSend the message to cockpit@pitboardsuite.com to finalize.",
      closeBtn:      'Close',
      ariaLabel:     'Pricing contact',
      subjectPrefix: 'Pricing request',
      bodyLines: {
        nom: 'Name', societe: 'Company', email: 'Email', tel: 'Phone', secteur: 'Industry', message: 'Message',
      },
    },
  },
};

// ─── Footer ───────────────────────────────────────────────────────────────────
export const FOOTER_CONTENT = {
  fr: {
    desc:       "Business Operating System pour les cabinets de courtage, d'assurance et d'assistance.",
    colProduct:  'Produit',
    colCompany:  'Entreprise',
    colSites:    'Sites',
    copy:        'Tous droits réservés',
  },
  en: {
    desc:       'Business Operating System for brokerage firms, insurance and assistance companies.',
    colProduct:  'Product',
    colCompany:  'Company',
    colSites:    'Sites',
    copy:        'All rights reserved',
  },
};

export const FOOTER_LINKS = {
  fr: {
    produit: [
      { label: 'Fonctionnalités', href: '#fonctionnalites' },
      { label: 'Solutions',       href: '#solutions' },
      { label: 'IA intégrée',     href: '#ia' },
      { label: 'Sécurité',        href: '#securite' },
      { label: 'Tarifs',          href: '#tarifs' },
    ],
    entreprise: [
      { label: 'À propos',                 href: '#pourquoi' },
      { label: 'Contact',                  href: '#contact' },
      { label: 'Mentions légales & CGU',   href: `${VITRINE_BASE}/legal` },
      { label: 'Informations pour les IA', href: `${VITRINE_BASE}/ia-info` },
    ],
  },
  en: {
    produit: [
      { label: 'Features',        href: '#fonctionnalites' },
      { label: 'Solutions',       href: '#solutions' },
      { label: 'AI Integration',  href: '#ia' },
      { label: 'Security',        href: '#securite' },
      { label: 'Pricing',         href: '#tarifs' },
    ],
    entreprise: [
      { label: 'About',              href: '#pourquoi' },
      { label: 'Contact',            href: '#contact' },
      { label: 'Legal & Terms',      href: `${VITRINE_BASE}/legal` },
      { label: 'Information for AI', href: `${VITRINE_BASE}/ia-info` },
    ],
  },
};

// ─── Demo Modal ───────────────────────────────────────────────────────────────
export const DEMO_MODAL = {
  fr: {
    label:        'Demande de démonstration',
    title:        'Prenons 30 minutes ensemble.',
    sub:          'Notre équipe vous présente PitBoard Suite adapté à votre métier.',
    fields: [
      { key: 'nom',     label: 'Nom complet',        type: 'text',  required: true,  placeholder: 'Jean Dupont' },
      { key: 'email',   label: 'Email professionnel', type: 'email', required: true,  placeholder: 'jean.dupont@societe.fr' },
      { key: 'societe', label: 'Société',             type: 'text',  required: true,  placeholder: 'Nom de votre société' },
      { key: 'poste',   label: 'Poste / Fonction',    type: 'text',  required: false, placeholder: 'Directeur, Responsable...' },
    ],
    submitBtn:      'Demander une démonstration',
    successTitle:   'Demande envoyée !',
    successMsg:     'Un membre de la team PitBoard revient vers vous rapidement pour fixer un rendez-vous.',
    closeBtn:       'Fermer',
    errors: {
      required: 'Ce champ est requis',
      email:    'Email invalide',
    },
    subjectPrefix:  'Demande de démo',
    bodyLabels:     { nom: 'Nom', email: 'Email', societe: 'Société', poste: 'Poste' },
  },
  en: {
    label:        'Demo request',
    title:        "Let's take 30 minutes together.",
    sub:          'Our team presents PitBoard Suite tailored to your industry.',
    fields: [
      { key: 'nom',     label: 'Full name',           type: 'text',  required: true,  placeholder: 'John Smith' },
      { key: 'email',   label: 'Professional email',  type: 'email', required: true,  placeholder: 'john.smith@company.com' },
      { key: 'societe', label: 'Company',              type: 'text',  required: true,  placeholder: 'Your company name' },
      { key: 'poste',   label: 'Position / Title',     type: 'text',  required: false, placeholder: 'Director, Manager...' },
    ],
    submitBtn:      'Request a demonstration',
    successTitle:   'Request sent!',
    successMsg:     'A member of the PitBoard team will get back to you shortly to schedule a meeting.',
    closeBtn:       'Close',
    errors: {
      required: 'This field is required',
      email:    'Invalid email',
    },
    subjectPrefix:  'Demo request',
    bodyLabels:     { nom: 'Name', email: 'Email', societe: 'Company', poste: 'Position' },
  },
};

// ─── AI Modal ─────────────────────────────────────────────────────────────────
export const AI_MODAL = {
  fr: {
    label:      'Intelligence artificielle sur mesure',
    title:      "L'IA que votre métier\nmérite vraiment.",
    sub:        "PitBoard développe et intègre des solutions d'intelligence artificielle taillées pour les besoins réels du secteur assurance — pas des démos, des outils qui tournent en production.",
    footerNote: "Chaque solution est conçue avec votre équipe — de l'analyse du besoin au déploiement en production.",
    ctaBtn:     'Discutons de votre projet',
    useCases: [
      { iconKey: 'FileText',    title: 'Lecture automatique des bordereaux', desc: "Extraction et structuration des données de sinistres, primes et commissions directement depuis vos bordereaux PDF ou Excel." },
      { iconKey: 'Search',      title: 'Analyse intelligente des contrats',  desc: "Identification des clauses clés, détection des anomalies et résumé automatique de vos contrats d'assurance." },
      { iconKey: 'Mail',        title: 'Rédaction assistée des courriers',   desc: "Génération automatique des emails, courriers de résiliation, avenant et réponses clients selon vos modèles." },
      { iconKey: 'AlertCircle', title: 'Détection des fraudes et alertes',   desc: "Analyse des dossiers de sinistres pour identifier des incohérences et déclencher des alertes intelligentes." },
      { iconKey: 'BarChart2',   title: "Synthèse des dossiers d'assistance", desc: "Résumé automatique des événements d'un dossier, chronologie et recommandations d'actions prioritaires." },
      { iconKey: 'Cpu',         title: 'Workflows sur mesure',               desc: "Chaque automatisation est conçue et calibrée selon votre processus métier exact — aucun modèle standard imposé." },
    ],
  },
  en: {
    label:      'Custom artificial intelligence',
    title:      "The AI your business\ntruly deserves.",
    sub:        "PitBoard develops and integrates artificial intelligence solutions tailored to the real needs of the insurance sector — not demos, tools that run in production.",
    footerNote: "Every solution is designed with your team — from needs analysis to production deployment.",
    ctaBtn:     "Let's discuss your project",
    useCases: [
      { iconKey: 'FileText',    title: 'Automatic bordereau reading',     desc: 'Extraction and structuring of claims, premium and commission data directly from your PDF or Excel bordereau files.' },
      { iconKey: 'Search',      title: 'Smart contract analysis',         desc: 'Identification of key clauses, anomaly detection and automatic summary of your insurance contracts.' },
      { iconKey: 'Mail',        title: 'Assisted correspondence drafting', desc: 'Automatic generation of emails, cancellation letters, endorsements and client responses based on your templates.' },
      { iconKey: 'AlertCircle', title: 'Fraud detection and alerts',      desc: 'Analysis of claim files to identify inconsistencies and trigger smart alerts.' },
      { iconKey: 'BarChart2',   title: 'Assistance file summaries',       desc: 'Automatic summary of file events, timeline and priority action recommendations.' },
      { iconKey: 'Cpu',         title: 'Custom workflows',                desc: 'Each automation is designed and calibrated to your exact business process — no standard template imposed.' },
    ],
  },
};

// ─── SEO ─────────────────────────────────────────────────────────────────────
export const SITE_META = {
  fr: {
    siteUrl:     'https://pitboardsuite.com',
    title:       'PitBoard Suite — Logiciel de gestion assurance | CRM courtier & cabinet de courtage',
    description: "PitBoard Suite est le logiciel de gestion assurance tout-en-un : CRM courtier, logiciel pour cabinet de courtage, ERP assurance, logiciel d'assistance. Bien plus qu'un CRM — une plateforme complète pour courtiers, assisteurs et compagnies.",
    keywords:    'logiciel de gestion assurance, logiciel courtier assurance, logiciel cabinet de courtage, CRM assurance, CRM courtier, ERP assurance, logiciel assistance, plateforme assurance, gestion cabinet assurance, logiciel pour courtier',
  },
  en: {
    siteUrl:     'https://pitboardsuite.com',
    title:       'PitBoard Suite — Insurance Management Software | Broker CRM & Insurance ERP',
    description: "PitBoard Suite is the all-in-one insurance management software: broker CRM, insurance management system, insurance ERP, assistance management software. Far beyond a CRM — a complete platform for brokers, assistance companies and insurers.",
    keywords:    'insurance management software, broker CRM, insurance ERP, insurance company software, broker management software, assistance management software, insurance platform, SaaS insurance, insurance business software',
  },
};

// ─── Legal (données fixes — non traduit, contenu juridique FR) ────────────────
export const LEGAL = {
  company:     'JOERKE.B',
  form:        'SASU — Société par actions simplifiée unipersonnelle',
  capital:     'À compléter',
  siren:       '892 906 728',
  siret:       '892 906 728 00019',
  rcs:         '892 906 728 R.C.S. Troyes',
  tva:         'FR12892906728',
  address:     '11 Rue Urbain IV, 10000 Troyes, France',
  president:   'Arnaud Becam',
  publication: 'Arnaud Becam',
  email:       'cockpit@pitboardsuite.com',
  hosting: [
    { name: 'OVH SAS',                    address: '2 rue Kellermann, 59100 Roubaix, France',         url: 'https://www.ovhcloud.com' },
    { name: 'Hostinger International Ltd', address: '61 Lordou Vironos Street, 6023 Larnaca, Chypre', url: 'https://www.hostinger.fr' },
  ],
};
